import React from "react";
import { ShieldCheckIcon, BuildingOffice2Icon } from "@heroicons/react/20/solid";
import ReporteUsoPlataforma from "./ReporteUsoPlataforma";
import AdminStats from "../AdminStats";

// Catálogo de los reportes de PLATAFORMA (ruta /dashboard/reportes-admin).
// Separado de registry.js a propósito: aquel habla siempre de un venue y
// estos cruzan todos. Mezclarlos obligaba a un `adminOnly` que se colaba en
// la navegación de los owners.
export const REPORTES_ADMIN = [
  {
    id: "uso-plataforma",
    titulo: "Uso de la plataforma",
    descripcion:
      "Quién entra al panel y quién no, usuario por usuario, con su última actividad. Se puede acotar a un venue.",
    Icon: ShieldCheckIcon,
    Component: ReporteUsoPlataforma,
  },
  {
    id: "actividad-venues",
    titulo: "Actividad por venue",
    descripcion:
      "Qué tan vivo está cada venue: cambios en bitácora, clics a redes, leads en pipeline y horas de presencia de su gente.",
    Icon: BuildingOffice2Icon,
    // El mismo componente de la vieja pantalla Admin Stats, sin su cromo.
    Component: () => <AdminStats embebido />,
  },
];

export const reporteAdminPorId = (id) =>
  REPORTES_ADMIN.find((r) => r.id === id) || null;
